export default "__VITE_ASSET__D$mD1$Ny__"